var _a;
import * as tslib_1 from "tslib";
import { deviationSchema } from '../normalizr/schemas/deviation';
import { userSchema } from '../normalizr/schemas/user';
// we want to preserve expandables if the incoming entity was not expanded
// otherwise, overwrite everything
function preserveExisting(existing, incoming) {
    if (existing !== undefined && incoming === undefined) {
        return existing;
    }
    return incoming;
}
function mergeTextContent(existing, incoming) {
    if (!existing || !incoming) {
        return incoming;
    }
    // if the existing is expanded, and the incoming is not, keep the existing
    // do not attempt to merge to avoid tearing between excerpt and markup
    if (existing.html.markup !== undefined &&
        incoming.html.markup === undefined) {
        return existing;
    }
    return incoming;
}
function dropUndefined(thing) {
    var copy = {};
    Object.keys(thing).forEach(function (key) {
        if (thing[key] !== undefined) {
            copy[key] = thing[key];
        }
    });
    return copy;
}
function mergeDeviationEntity(existing, incoming) {
    var merged = tslib_1.__assign({}, incoming, { textContent: mergeTextContent(existing.textContent, incoming.textContent), dailyDeviation: preserveExisting(existing.dailyDeviation, incoming.dailyDeviation), print: preserveExisting(existing.print, incoming.print), pcp: preserveExisting(existing.pcp, incoming.pcp), background: preserveExisting(existing.background, incoming.background), extended: preserveExisting(existing.extended, incoming.extended) });
    return dropUndefined(merged);
}
function mergeUserEntity(existing, incoming) {
    var merged = tslib_1.__assign({}, incoming, { details: preserveExisting(existing.details, incoming.details), geo: preserveExisting(existing.geo, incoming.geo), profile: preserveExisting(existing.profile, incoming.profile), stats: preserveExisting(existing.stats, incoming.stats), isWatching: preserveExisting(existing.isWatching, incoming.isWatching) });
    return dropUndefined(merged);
}
export var entityMergers = (_a = {},
    _a[deviationSchema.key] = mergeDeviationEntity,
    _a[userSchema.key] = mergeUserEntity,
    _a);
//# sourceMappingURL=mergeStrategies.js.map